import { emptyObject } from 'utils/constants/common';
import { STAGE_STREAM_MODES } from '../../utils/constants/stageStreamModes';
import createReducer from '../../utils/createReducer';
import { logger } from '../../utils/logger';
import {
    ADD_STAGE_INVITATION,
    BREAKOUT_ROOM_JOIN_STATUS,
    CHANGE_PENDING_INVITATION_FLAG,
    CHANGE_RESOLUTION_MENU_STATUS,
    LIVE_AIRMEET_SET_DATA,
    LIVE_AIRMEET_UPDATE_REACTIONS_LIST,
    sessionBaseProps,
    SET_ACTIVE_WATCH_MODE,
    SET_AIRMEET_VISIT_ID,
    SET_BREAKOUT_ACTIVE,
    SET_DEFAULT_BACKDROP,
    SET_FILTER_ENABLED,
    SET_FILTER_INFO,
    SET_INVITED_SPEAKERS_DATA,
    SET_IN_AIRMEET_PERMISSION_SETUP_COMPLETE,
    SET_LAST_DM_NOTIFICATION_TIME,
    SET_LITE_MODE_ENABLED,
    SET_LOCAL_STREAM_IN_MIRROR,
    SET_PERMISSION_SETUP_COMPLETE,
    SET_PERMISSION_WORKFLOW_VERSION,
    SET_SOCIAL_STREAMING,
    SET_STAGE_MEMBER_LIMIT_REACHED,
    SET_STREAM_LIMIT_MODAL_VISIBILITY,
    SET_TABLE_CODE,
    UPDATE_CHECK_DM_NOTIFICATION_THRESHOLD,
    UPDATE_STAGE_ONLINE_MEMBERS,
    UPDATE_USER_PRESENCE_MEMBERS,
} from '../actions/liveAirmeet';
const liteVersionLog = logger.init('Lite version', 'blue');

const initialState = {
    currentState: '',
    liteModeActive: false,
    isStreamLimitModalVisible: false,
    hasStageMemberLimitReached: false,
    genral: {
        layout: {},
    },
    invitations: {},
    invitedSpeakers: {},
    pendingInvitationPresent: false,
    sessions: {},
    stageMembers: {},
    membersInContext: {},
    tableCode: null,
    activeWatchMode: STAGE_STREAM_MODES.highResolution,
    mirrorVideo: true,
    checkDMNotificationThreshold: false,
    lastDMNotificationTime: 0,
    socialStreaming: false,
    filterInfo: {
        type: 'none',
    },
    filterEnabled: false,
    permissionWorkflowVersion: 2,
    isBreakoutActive: false,
    inAirmeetPermissionSetupComplete: false,
    isPermissionSetupComplete:
        localStorage.getItem('is_permission_setup_complete') || false,
};

const handlers = {
    [SET_PERMISSION_SETUP_COMPLETE]: (state = initialState, { payload }) => {
        if (payload) {
            localStorage.setItem('is_permission_setup_complete', payload);
        } else {
            localStorage.removeItem('is_permission_setup_complete');
        }
        return state.isPermissionSetupComplete === payload
            ? state
            : { ...state, isPermissionSetupComplete: payload };
    },
    [SET_IN_AIRMEET_PERMISSION_SETUP_COMPLETE]: (
        state = initialState,
        { payload }
    ) => {
        if (payload) {
            localStorage.setItem(
                'inairmeet_permission_setup_complete',
                payload
            );
        } else {
            localStorage.removeItem('inairmeet_permission_setup_complete');
        }
        return state.inAirmeetPermissionSetupComplete === payload
            ? state
            : { ...state, inAirmeetPermissionSetupComplete: payload };
    },
    [LIVE_AIRMEET_SET_DATA]: (state = initialState, { payload }) => {
        if (
            JSON.stringify(state) === JSON.stringify({ ...state, ...payload })
        ) {
            return state;
        }
        if (payload.sessions) {
            const sessions = {};
            Object.keys(payload.sessions).forEach((sessionId) => {
                sessions[sessionId] = {
                    ...sessionBaseProps,
                    ...payload.sessions[sessionId],
                };
            });
            payload.sessions = sessions;
        }
        // console.log(JSON.stringify(state));
        // console.log(JSON.stringify({ ...state, ...payload }));
        return { ...state, ...payload };
    },
    [LIVE_AIRMEET_UPDATE_REACTIONS_LIST]: (
        state = initialState,
        { payload }
    ) => {
        let { sessions } = state;
        const { sessionId, reactions } = payload;
        if (!sessions[sessionId]) {
            sessions[sessionId] = sessionBaseProps;
        }
        sessions[sessionId].reactions = reactions;
        return { ...state, sessions: { ...sessions } };
    },
    // [LIVE_AIRMEET_UPDATE_STREAMS_LAYOUT]: (
    //     state = initialState,
    //     { payload }
    // ) => {
    //     state.genral.layout = payload;
    //     return { ...state };
    // },
    [UPDATE_STAGE_ONLINE_MEMBERS]: (state = initialState, { payload }) => {
        if (!state.stageMembers[payload.stageId]) {
            state.stageMembers[payload.stageId] = {};
        }
        state.stageMembers[payload.stageId] = { ...payload.members };
        return state;
    },
    [UPDATE_USER_PRESENCE_MEMBERS]: (state = initialState, { payload }) => {
        if (!state.membersInContext[payload.presenceIn]) {
            state.membersInContext[payload.presenceIn] = {};
        }
        state.membersInContext[payload.presenceIn] = { ...payload.members };
        return state;
    },
    [SET_LITE_MODE_ENABLED]: (state, { payload }) => {
        liteVersionLog('liteMode visibility state updated to', payload);
        return { ...state, liteModeActive: payload };
    },
    [SET_ACTIVE_WATCH_MODE]: (state, { payload = 'default' }) => {
        return { ...state, activeWatchMode: payload };
    },
    [SET_INVITED_SPEAKERS_DATA]: (state, { payload = emptyObject }) => {
        return { ...state, invitedSpeakers: { ...payload } };
    },
    [CHANGE_RESOLUTION_MENU_STATUS]: (state, { payload }) => {
        return { ...state, isResolutionMenuOpen: payload };
    },
    [ADD_STAGE_INVITATION]: (state = initialState, { payload }) => {
        state.invitations = payload;
        return { ...state };
    },
    [CHANGE_PENDING_INVITATION_FLAG]: (state = initialState, { payload }) => {
        state.pendingInvitationPresent = payload;
        return { ...state };
    },
    [SET_STREAM_LIMIT_MODAL_VISIBILITY]: (
        state = initialState,
        { payload }
    ) => {
        state.isStreamLimitModalVisible = payload;
        return { ...state };
    },
    [SET_STAGE_MEMBER_LIMIT_REACHED]: (state = initialState, { payload }) => {
        if (state.hasStageMemberLimitReached === payload) {
            return state;
        }
        state.hasStageMemberLimitReached = payload;
        return { ...state };
    },
    [SET_TABLE_CODE]: (state = initialState, { payload }) => {
        return { ...state, tableCode: payload };
    },
    [SET_AIRMEET_VISIT_ID]: (state, { payload }) => {
        return { ...state, airmeetVisitId: payload };
    },
    [SET_DEFAULT_BACKDROP]: (state, { payload }) => {
        return { ...state, defaultBackdrop: payload };
    },
    [SET_LOCAL_STREAM_IN_MIRROR]: (state) => {
        return {
            ...state,
            mirrorVideo: !state.mirrorVideo,
        };
    },
    [UPDATE_CHECK_DM_NOTIFICATION_THRESHOLD]: (
        state = initialState,
        { payload }
    ) => {
        return {
            ...state,
            checkDMNotificationThreshold: payload,
        };
    },
    [SET_LAST_DM_NOTIFICATION_TIME]: (state = initialState, { payload }) => {
        return {
            ...state,
            lastDMNotificationTime: payload,
        };
    },
    [SET_SOCIAL_STREAMING]: (state, { payload }) => {
        return { ...state, socialStreaming: payload };
    },
    [SET_FILTER_INFO]: (state, { payload }) => ({
        ...state,
        filterInfo: payload,
    }),
    [SET_FILTER_ENABLED]: (state = initialState, { payload }) => ({
        ...state,
        filterEnabled: payload,
    }),
    [SET_PERMISSION_WORKFLOW_VERSION]: (state = initialState, { payload }) => ({
        ...state,
        permissionWorkflowVersion: payload,
    }),
    [SET_BREAKOUT_ACTIVE]: (state, { payload }) => {
        return { ...state, isBreakoutActive: payload };
    },
    [BREAKOUT_ROOM_JOIN_STATUS]: (state = initialState, { payload }) => ({
        ...state,
        isJoinedBreakoutRoom: payload,
    }),
};

export default createReducer(initialState, handlers);
